import ObjectHelper from "./ObjectHelper.js";
const idCounts = ObjectHelper.getPathDefault(globalThis, "bryntum.idCounts", /* @__PURE__ */ Object.create(null));
class IdHelper {
  /**
   * Generate a new id, using IdHelpers internal counter and a prefix
   * @param {String} prefix Id prefix
   * @returns {String} Generated id
   */
  static generateId(prefix = "generatedId") {
    return prefix + (idCounts[prefix] = (idCounts[prefix] || 0) + 1);
  }
  static reset(prefix) {
    idCounts[prefix] = 0;
  }
}
IdHelper._$name = "IdHelper";
export {
  IdHelper as default
};
